import React from 'react';
import { useSelector } from 'react-redux';
import Styled from 'App/styled';
import { platformNames } from 'shared/constants';
import NykaaManLogo from 'components/Icons/NykaaManLogo';
import NykaaLogo from 'components/Icons/NykaaLogo';
import { State } from 'shared/store/types';
import { LINKS, MAN_LINKS } from 'constants/footer';

const Wrapper = Styled.div`
  background-color: ${({ theme }) => theme.footerLinks};
  color: #fff;
  padding: 45px 0px 30px 0px;
  width: 100%;
  display: flex;
  justify-content:center;
`;
const Container = Styled.div<{ isMan: boolean }>`
  max-width: 1200px;
  width:100%;
  padding: 0 30px;
  display:flex;
  svg {
    height: 37px;
    ${({ isMan }) => !isMan && 'width: 72px'};
    margin-bottom: 20px;
  }
  path {
    fill: #fff;
  }
`;

const ListWrapper = Styled.div`
  padding: 10px;
  width: ${(props) => props.width}%;
  header{
    margin-bottom: 20px;
    ${({ theme }) => theme.typography.subTitleMedium};
  }
`;

const Item = Styled.li`
  ${({ theme }) => theme.typography.bodySmall};
  margin-bottom: 11px;
  &.double {
    display: inline-block;
    width: 50%;
  }
`;

const Link = Styled.a`
  color: inherit;
  display: inline-block;
  transition: all ease-in-out 300ms;
  text-decoration: none;
  &: hover {
    color: ${(props) => props.theme.footerHoverLink};
  }
`;
const List = Styled.ul`
  list-style: none;
`;

const Component = () => {
  let { footerLinks = {} } = useSelector(
    (state: State) => state.remoteConfig.configs
  );
  if (!Object.keys(footerLinks).length) {
    footerLinks = __PLATFORM__ == platformNames.MEN ? MAN_LINKS : LINKS;
  }
  const Logo = __PLATFORM__ == platformNames.MEN ? NykaaManLogo : NykaaLogo;
  return (
    <Wrapper>
      <Container isMan={__PLATFORM__ === platformNames.MEN}>
        {Object.keys(footerLinks).map((key, idx) => (
          <ListWrapper
            key={`links-${key}`}
            width={100 / Object.keys(footerLinks).length}
          >
            {idx === 0 && <Logo />}
            {idx > 0 && (
              <header
                role="heading"
                aria-level={2}
              >
                {key}
              </header>
            )}
            <List>
              {footerLinks[key].map(
                (link, index) =>
                  link.displayAs && (
                    <Item
                      key={`nl2-${index}`}
                      className={link?.className}
                    >
                      <Link
                        href={link.redirectTo}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {link.displayAs}
                      </Link>
                    </Item>
                  )
              )}
            </List>
          </ListWrapper>
        ))}
      </Container>
    </Wrapper>
  );
};

export default Component;
